/* eslint-disable react/forbid-prop-types,import/prefer-default-export,import/no-unresolved */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { isIOS } from 'react-device-detect';
import { useHistory } from 'react-router-dom';
import { MAIN_ICON_COLORS } from 'assets/components';
import { OnboardingBodyLayout } from '../partials';
import { ACCOUNT_REGIONS } from '../../../../utilities/constants';
import { handleUserEnvironmentUrl } from '../../../../utilities/helpers';
import Icon from '../../../../components/Icon';
import { ICONS } from '../../../../components/Icon/constants';
import { cacheUserEnvironment } from '../../../../utilities/caching';
import Input from '../../../../components/Input';

export const LoginComponent = ({
  form,
  accountRegion,
  handleSubmitForm,
  allowSeparateEnv,
  renderButtons,
  handleChange,
  handleBlur,
  clearFormError,
  resetPasswordRedirect,
  revealPassword,
}) => {
  const { t: translate } = useTranslation();
  const history = useHistory();

  const renderAccountRegionTabs = () => (
    <div className="d-flex flex-row align-items-center mt-4 w-100 gap-3 flex-md-fill mb-md-3">
      <div
        className={`d-flex flex-column align-items-center py-3 border rounded-extra w-50 border-2 ${
          accountRegion === ACCOUNT_REGIONS.UK_OR_EU
            ? 'bg-lighter border-primary-dimmed'
            : 'bg-light border-grey-lighter'
        }`}
        role="button"
        tabIndex="-1"
        onClick={() => {
          handleUserEnvironmentUrl('onboarding/login', true);
        }}
        onKeyDown={() => {}}>
        <Icon icon={ICONS.INTERNATIONAL} color={MAIN_ICON_COLORS.WHITE} />
        <p
          className={`text-f6 mt-2 ${
            accountRegion === ACCOUNT_REGIONS.UK_OR_EU ? 'text-dark' : 'text-shadow'
          }`}>
          {translate('login_uk_eu_account_tab_title')}
        </p>
      </div>
      <div
        className={`d-flex flex-column align-items-center py-3 border rounded-extra w-50 border-2 ${
          accountRegion === ACCOUNT_REGIONS.US
            ? 'bg-lighter border-primary-dimmed'
            : 'bg-light border-grey-lighter'
        }`}
        role="button"
        tabIndex="-1"
        onClick={() => {
          cacheUserEnvironment(ACCOUNT_REGIONS.US);
          handleUserEnvironmentUrl('onboarding/login');
        }}
        onKeyDown={() => {}}>
        <Icon icon={ICONS.USA} color={MAIN_ICON_COLORS.WHITE} />
        <p
          className={`text-f6 mt-2 ${
            accountRegion === ACCOUNT_REGIONS.US ? 'text-dark' : 'text-shadow'
          }`}>
          {translate('login_us_account_tab_title')}
        </p>
      </div>
    </div>
  );

  return (
    <OnboardingBodyLayout
      withBack
      onPrevClick={() => history.push(`/promo`)}
      renderButtons={renderButtons}
      title={translate('signin_title')}>
      {allowSeparateEnv && renderAccountRegionTabs()}
      <form onSubmit={handleSubmitForm} id="login-form">
        <Input
          groupClassName={`my-4 ${isIOS ? 'ios' : ''}`}
          type="email"
          className={`form-control-input ${isIOS ? 'ios' : ''}`}
          placeholder={translate('email_input_label')}
          label={translate('email_input_label')}
          errorLabel={translate('email_input_error_label')}
          name="username"
          value={form.username}
          onChange={handleChange}
          onBlur={handleBlur}
          required
          withFloatingLabel
          withErrorLabel
        />
        <Input
          groupClassName={`mb-4 mt-0 ${isIOS ? 'ios' : ''}`}
          type="password"
          className={`form-control-input ${isIOS ? 'ios' : ''}`}
          placeholder={translate('password_input_label')}
          label={translate('password_input_label')}
          errorLabel={translate('password_input_error_label')}
          name="password"
          value={form.password}
          onChange={handleChange}
          onBlur={handleBlur}
          onFocus={clearFormError}
          autoComplete="current-password"
          required
          withFloatingLabel
          withErrorLabel
          inputGroupChildren={
            <>
              <span
                className="icon icon-open-icon h4 text-shadow"
                role="button"
                onClick={revealPassword}
                onKeyDown={null}
                tabIndex={-1}
                aria-label="Reveal password"
              />
            </>
          }
        />
      </form>
      <div className="">
        <button
          onClick={() => {
            resetPasswordRedirect();
          }}
          type="button"
          className="link text-decoration-none text-f5 border-0 bg-transparent text-bold text-primary p-0">
          {translate('having_trouble_link_label')}
        </button>
      </div>
    </OnboardingBodyLayout>
  );
};

LoginComponent.propTypes = {
  form: PropTypes.object.isRequired,
  accountRegion: PropTypes.string.isRequired,
  handleSubmitForm: PropTypes.func.isRequired,
  allowSeparateEnv: PropTypes.bool,
  renderButtons: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  clearFormError: PropTypes.func.isRequired,
  resetPasswordRedirect: PropTypes.func.isRequired,
  revealPassword: PropTypes.func.isRequired,
};

LoginComponent.defaultProps = {
  allowSeparateEnv: false,
};
